import logo from "../../assets/logo-utahcompose.png";

export default function UtahComposeLogo() {
	return (
		<div className="left-0 shrink-0 static">
			<span className="sr-only">Utah Compose</span>
			<img className="h-12 w-auto" id="utah-compose-logo" src={logo} alt="Utah Compose" />
		</div>
	);
}
